import { render, staticRenderFns } from "./SaveUsedCarLink.vue?vue&type=template&id=4e9ddaba&scoped=true&lang=html"
import script from "./SaveUsedCarLink.vue?vue&type=script&lang=js"
export * from "./SaveUsedCarLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ddaba",
  null
  
)

export default component.exports